import script from "./SubscriptionBenefitsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionBenefitsItem.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionBenefitsItem.vue?vue&type=style&index=0&id=b838f882&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b838f882"]])

export default __exports__